module.exports = __webpack_public_path__ + "/bundle/asset/U1_02-e15085fca02eebb7238f79e7be89429c.gif";